import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  link?: boolean;
  timerTime?: any;
  errorCase?: boolean;
}

const useCountdownTimer = (props: Props) => {
  const { timerTime, errorCase } = props;
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(timerTime);

  // link ? 60 : 120

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  useEffect(() => {
    if (errorCase) {
      setSeconds(0);
    }
  }, [errorCase]);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return { t, minutes, remainingSeconds, seconds, setSeconds };
};

export default useCountdownTimer;
